import { msg } from "@lingui/core/macro";

export const recurringAvailabilityWindowRuleMessages = {
	name: msg({ message: "Recurring Availability Window" }),
	description: msg({ message: "Permits may only be created during the configured recurring availability windows" }),
	errors: {
		isOutsideWindow: msg({
			message: "Permits can only be created during this option's scheduled availability windows",
		}),
	},
} as const;
